import { Button } from './Button';
import { CircularProgress } from './CircularProgress';
import { Link } from './Link';
import { Modal } from './Modal';
import { Spinner } from './Spinner';
import { Table } from './Table';

export default { Button, Modal, Spinner, Table, Link, CircularProgress };
